import { render, staticRenderFns } from "./TeacherCourseView.vue?vue&type=template&id=3fd12342"
import script from "./TeacherCourseView.vue?vue&type=script&lang=js"
export * from "./TeacherCourseView.vue?vue&type=script&lang=js"
import style0 from "./TeacherCourseView.vue?vue&type=style&index=0&id=3fd12342&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports